export const FILE_NAME = 'file_name'
export const FILE_URL = 'file_url'

export const initialImageFileValues = {
  [FILE_NAME]: '',
  [FILE_URL]: ''
}
